import React from "react";
import { UploadAlbumTrackLoaderTemplate } from "themes/common/components";

const UploadAlbumTrackLoader = (props) => {
    return <UploadAlbumTrackLoaderTemplate {...props} />;
};

export default UploadAlbumTrackLoader;
